/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S7_TitleInputs */

const en_guide_large_json_files_s7_title = /** @type {(inputs: Guide_Large_Json_Files_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategies when files get big`)
};

const ko_guide_large_json_files_s7_title = /** @type {(inputs: Guide_Large_Json_Files_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일이 커질 때의 전략`)
};

const ja_guide_large_json_files_s7_title = /** @type {(inputs: Guide_Large_Json_Files_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルが大きくなったときの戦略`)
};

/**
* | output |
* | --- |
* | "Strategies when files get big" |
*
* @param {Guide_Large_Json_Files_S7_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s7_title = /** @type {((inputs?: Guide_Large_Json_Files_S7_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S7_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s7_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s7_title(inputs)
	return ja_guide_large_json_files_s7_title(inputs)
});